import AccountSetupCard from './AccountSetupCard';

export default AccountSetupCard;
